import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stationIconMap' })
export class StationIconMapPipe implements PipeTransform {
  transform(station): any {
    const stationType = station?.['type'];
    return stationType === 'gma' || stationType === '3' ? 'road' : 'house-day';
  }
}
